import React from "react";
import "./CardSkeleton.css";

/* A lightweight placeholder shown while the dashboard chunk / menu list loads,
   so the user sees shimmering card outlines instead of a spinner or a blank
   lavender screen. Self-contained styling — works inside or outside .cdash/.adash. */

const Bar = ({ w = "100%", h = 12, mt = 12 }: { w?: string; h?: number; mt?: number }) => (
  <div className="cd-skl" style={{ width: w, height: h, marginTop: mt }} />
);

const SkelCard = ({ rows = 5, height = 320 }: { rows?: number; height?: number }) => (
  <div
    style={{
      background: "#ffffff",
      border: "1px solid #e3def3",
      borderRadius: 16,
      padding: "16px 18px",
      minHeight: height,
    }}
  >
    <div className="cd-skl" style={{ width: "44%", height: 16 }} />
    <div style={{ borderTop: "1px solid #efeafc", margin: "16px 0 4px" }} />
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 14 }}>
        <div className="cd-skl" style={{ width: 26, height: 26, borderRadius: "50%", flex: "0 0 26px" }} />
        <div className="cd-skl" style={{ flex: 1, height: 12 }} />
        <div className="cd-skl" style={{ width: 70, height: 12 }} />
      </div>
    ))}
  </div>
);

const DashboardSkeleton = ({ cards = 4 }: { cards?: number }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: 16,
    }}
  >
    {Array.from({ length: cards }).map((_, i) => (
      <SkelCard key={i} />
    ))}
  </div>
);

export default DashboardSkeleton;
